import { render, staticRenderFns } from "./VehicleCreateView.vue?vue&type=template&id=5f72206a"
import script from "./VehicleCreateView.vue?vue&type=script&lang=js"
export * from "./VehicleCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports